import { FEED_TYPES } from "./feed-types";

const FEED_SURFACE_KEYS = FEED_TYPES.flatMap(
  (t) => [`feed:${t}`, `feed:${t}:filtered`] as const,
);

/**
 * Surface enum: the set of screens that render tracked status lists. A framework-neutral domain
 * constant so the wire schema (impression-event) and the React SurfaceProvider can both depend on
 * it without the data/schema layer pulling in the UI context module.
 */
export const SURFACE_KEYS = [
  "group:timeline",
  "profile:statuses",
  "profile:replies",
  "status:detail",
  "thread:ancestor",
  "thread:descendant",
  ...FEED_SURFACE_KEYS,
] as const;

export type SurfaceKey = (typeof SURFACE_KEYS)[number];
